import {FragilityComponent} from './types';

type Variable = 'activities' | 'network' | 'services' | 'distress';
type Questions = Record<Variable, string>;

interface Condition {
    question: string;
    present: string[];
    absent: string[];
}

const UPDATE_QUESTIONS: Questions = {activities: '5', network: '6_', services: '9_', distress: '10'};

export const ACTIVITIES_MAPPING = {
    beneficiaries: {question: '10', column: 'numero'},
};

export const BENEFICIARIES_MAPPING = {
    fragility: {
        no_family_of_origin: {question: '9_', present: ['2'], absent: ['1']},
        family_psychological_problems: {question: '12_', present: ['1'], absent: ['2']},
        irregular_attendance: {question: '13b', present: ['2'], absent: ['1']},
        failed_school_year: {question: '13c', present: ['1', '2'], absent: ['3']},
        few_friends: {question: '15_', present: ['3'], absent: ['1', '2']},
        diagnosis: {question: '17_', present: ['1'], absent: ['2']},
    } as Record<FragilityComponent, Condition>,
    min_fragility_components: 4,
    services: {present: ['1'], absent: ['2']},
    distress: {none: ['15'], unknown: ['16']},
    activities: {
        rows: [
            'passare_il_tempo_con_gli_amici_a_casa_o_fuori',
            'guardare_serie_film_cartoni',
            'giocare_al_computer_o_ai_videogiochi',
            'ascoltare_la_musica',
            'leggere_un_libro_o_un_fumetto_non_per_scuola',
            'seguire_un_corso_extrascolastico_musica_inglese_teatro_ecc',
            'suonare_uno_strumento',
            'praticare_unattivita_sportiva_agonistica',
            'praticare_attivita_fisica_o_attivita_sportive_non_agonistiche',
        ],
        weekly: ['Tutti i giorni', 'Una o più volte a settimana'],
        unknown: ['Non saprei'],
    },
    network: {scores: {'1': 3, '2': 2, '3': 1}},
    questions: {
        initial: {activities: '14', network: '15_', services: '18_', distress: '19'} as Questions,
        update: UPDATE_QUESTIONS,
        final: {
            section: 'question1',
            sections: {
                '1': UPDATE_QUESTIONS,
                '2': {activities: 'domanda19', network: 'domanda20', services: 'domanda27', distress: 'domanda29'},
                '3': {activities: 'domanda22', network: 'domanda23', services: 'domanda32', distress: 'domanda34'},
            } as Record<string, Questions>,
        },
    },
};
